/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};


function validateForm() {
  //if ($("#i-agree-to-term").prop('checked') == false) {
  //  alert($("#i-agree-to-term-warning").val());
  //  return false;
  //}
  
  return true;
}


function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.iheartz.shop';
}
function validURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}

function CreateCreateCardFeeProduct(fee){
 return $.ajax({
            type: 'POST',
            // make sure you respect the same origin policy with this url:
            // http://en.wikipedia.org/wiki/Same_origin_policy
	        crossDomain: true,
            url: 'https://iheartzshop-api.herokuapp.com/api/iheartzshop/v1/products/card-fee',
             data: {price: fee},
            success: function(response){
              return response;              
            }
        }); 
  
}
function addFeeToCart(id){
  return jQuery.post('/cart/add.js', {
          "quantity": 1,
          "id": id,
          "attributes[feeId]": id
        })
}
function DeleteCardFeeProduct(ID){
           return $.ajax({
            url: "/cart/change.js",
            type: "POST",
            data: {
              id: ID,
              quantity: 0
            }
          });  
}

$("#admin_search_button").on("click", function(){
  $.ajax({
    type: 'POST',
    crossDomain: true,
    url: "https://iheartzshop-api.herokuapp.com/api/get_customer",
    data: JSON.stringify({"query": $("#admin_search_field").val() }),
    success: function(response){    
      $("#admin_search_result").empty();
      for(var i = 0 ; i < response.customers.length ; i++){
        var extraInfo = "";
        if(response.customers[i].note){
        	extraInfo = parameterToObject(response.customers[i].note);
        }
        var customerRow = "";
        
        var id = extraInfo?extraInfo.id:"";
        var birthday = extraInfo?extraInfo.birthday:"";
        var fbLink = extraInfo?extraInfo.fbLink:"#";
        
        customerRow += "<tr>";
        customerRow += "<td width='20%' style='padding-top:10px;'><b>客戶編號</b></td>";  
        customerRow += "<td width='20%'><b>姓名（會員編號）</b></td>";       
        customerRow += "<td width='20%'><b>生日</b></td>";       
        customerRow += "<td width='20%'><b>電郵</b></td>";  
        customerRow += "<td width='20%'></td>";  
        customerRow += "</tr>";
        
        customerRow += "<tr>";
        customerRow += "<td width='20%'>" + response.customers[i].id + "</td>";  
        customerRow += "<td width='20%'>" + response.customers[i].first_name + " " + response.customers[i].last_name + " (" + id + ")</td>";     
        customerRow += "<td width='20%'>" + birthday + "</td>";       
        customerRow += "<td width='20%'>" + response.customers[i].email + "</td>";  
        customerRow += "<td width='20%' style='text-align:center'><a target='_blank' href='" + fbLink + "'>FB連結</a></td>";  
        customerRow += "</tr>";

        customerRow += "<tr style='border-bottom: 1px solid rgba(0,0,0,0.1)'>";
        if(response.customers[i].default_address){
          customerRow += "<td colspan='3' style='padding-bottom:60px;vertical-align: top;'><b>地址</b> <br/>" + response.customers[i].default_address.first_name + " " + response.customers[i].default_address.last_name + "<br/>" + response.customers[i].default_address.phone + "<br/>" + response.customers[i].default_address.address1 + "<br/>" + response.customers[i].default_address.address2 + "<br/>" +response.customers[i].default_address.city + " " + response.customers[i].default_address.country + " " + response.customers[i].default_address.zip +"</td>";  
        }else{
         	customerRow += "<td colspan='3' style='padding-bottom:60px;vertical-align: top;'><b>地址</b> <br/></td>";   
        }
        customerRow += "<td colspan='2' style='vertical-align: top;'> <b>訂單總數：</b>" + response.customers[i].orders_count + "<br/><b>訂單資出：</b>" + response.customers[i].total_spent + "</td>";  
        customerRow += "</tr><hr/>";
        
        $("#admin_search_result").append(customerRow);
      }
      $("#admin_search_result").show();
    }
  });
});


$('#admin_search_field').on("keypress", function(e) {
  $.ajax({
    type: 'POST',
    crossDomain: true,
    url: "https://iheartzshop-api.herokuapp.com/api/get_customer",
    data: JSON.stringify({"query": $("#admin_search_field").val() }),
    success: function(response){  
      $("#admin_search_result").empty();
      for(var i = 0 ; i < response.customers.length ; i++){
        var extraInfo;
        
        if(response.customers[i].note){
        	var extraInfo = parameterToObject(response.customers[i].note);
        }
        var customerRow = "";
        
        var id = extraInfo?extraInfo.id:"";
        var birthday = extraInfo?extraInfo.birthday:"";
        var fbLink = extraInfo?extraInfo.fbLink:"#";
        
        customerRow += "<tr>";
        customerRow += "<td width='20%' style='padding-top:10px;'><b>客戶編號</b></td>";  
        customerRow += "<td width='40%'><b>姓名（會員編號）</b></td>";       
        customerRow += "<td width='10%'><b>生日</b></td>";       
        customerRow += "<td width='20%'><b>電郵</b></td>";  
        customerRow += "<td width='10%'></td>";  
        customerRow += "</tr>";
        
        customerRow += "<tr>";
        customerRow += "<td width='20%'>" + response.customers[i].id + "</td>";  
        customerRow += "<td width='40%'>" + response.customers[i].first_name + " " + response.customers[i].last_name + " (" + id + ")</td>";       
        customerRow += "<td width='10%'>" + birthday + "</td>";       
        customerRow += "<td width='20%'>" + response.customers[i].email + "</td>";  
        customerRow += "<td width='10%' style='text-align:center'><a target='_blank' href='" + fbLink + "'>FB連結</a></td>";  
        customerRow += "</tr>";

        customerRow += "<tr style='border-bottom: 1px solid rgba(0,0,0,0.1)'>";
        if(response.customers[i].default_address){
          customerRow += "<td colspan='3' style='padding-bottom:60px;vertical-align: top;'><b>地址</b> <br/>" + response.customers[i].default_address.first_name + " " + response.customers[i].default_address.last_name + "<br/>" + response.customers[i].default_address.phone + "<br/>"  + response.customers[i].default_address.address1 + "<br/>" + response.customers[i].default_address.address2 + "<br/>" +response.customers[i].default_address.city + " " + response.customers[i].default_address.country + " " + response.customers[i].default_address.zip +"</td>";  
        }else{
         	customerRow += "<td colspan='3' style='padding-bottom:60px;vertical-align: top;'><b>地址</b> <br/></td>";   
        }
        customerRow += "<td colspan='2' style='vertical-align: top;'> <b>訂單總數：</b>" + response.customers[i].orders_count + "<br/><b>訂單資出：</b>" + response.customers[i].total_spent + "</td>";  
        customerRow += "</tr><hr/>";
        
        $("#admin_search_result").append(customerRow);
      }
      $("#admin_search_result").show();
    }
  });
});

//Quick Search
$('#user_search_button').on("click", function(e) {
  e.preventDefault();
  
  $("#load-wrapper").show();
  
  $.ajax({
    type: 'POST',
    crossDomain: true,
    url: "https://iheartzshop-api.herokuapp.com/api/iheartzshop/v1/customers/search",
    data: {
      "query": "email:" + $("#user_search_field").val()
    },
    success: function(response){    
      $("#user_search_result").empty();
      
      var extraInfo;
      var id;
      var birthday;
      var fbLink;
      
      for(var i = 0 ; i < response.data.length ; i++){
        extraInfo = null;
        
        if(response.data[i].note){
        	extraInfo = parameterToObject(response.data[i].note);
        }
        var customerRow = "";
        
        id = extraInfo?extraInfo.id:"";
        birthday = extraInfo?extraInfo.birthday:"";
        fbLink = extraInfo?extraInfo.fbLink:"#";
        
        var lastname = response.data[i].last_name?response.data[i].last_name:'';
        
        customerRow += "<tr>"; 
        customerRow += "<td width='40%'><b>姓名（會員編號）</b></td>"; 
        customerRow += "<td width='20%'><b>生日</b></td>"; 
        customerRow += "<td width='20%'><b>郵區</b></td>"; 
        customerRow += "</tr>";
   
         
        var zip = response.data[i].addresses.length>0?response.data[i].addresses[0].zip:'';
        
        customerRow += "<tr>";
        customerRow += "<td width='40%'>" + response.data[i].first_name + " " + lastname + " (" + id + ")</td>";   
        customerRow += "<td width='20%'>" + birthday + " </td>";         
        customerRow += "<td width='20%'>" + zip + " </td>";         
        customerRow += "</tr>";
        
        
        $("#user_search_result").append(customerRow);
      }
      $("#user_search_result").show();
      $("#load-wrapper").hide();
    },
    error: function(response){
  		$("#load-wrapper").hide();
  	}
  });
});

function parameterToObject(target){
  
  if(target){
    target = target.replace("id=&","");

      var extraInfo = '{"' + target.replace(/&/g, '","').replace(/id=Z/g,'id":"Z').replace(/fbLink=/g,'fbLink":"').replace(/birthday=/g,'birthday":"').replace(/idCardNo=/g,'idCardNo":"').replace(/iAgree=/g,'iAgree":"') + '"}';

    if(extraInfo.length > 7){ 
      return JSON.parse(extraInfo, 
                 function(key, value) { 
        return key===""?value:decodeURIComponent(value) 
      })
    }else{
      return null;
    }
  }else{
   return null; 
  }
  
}